export type SettingsScope = { level: "deployment" } | { level: "team"; teamId: string } | { level: "project"; projectId: string };

export const settingsUrl = (scope: SettingsScope, search?: URLSearchParams): string => {
  const params = new URLSearchParams({ scope: scope.level });
  if (scope.level === "team") params.set("teamId", scope.teamId);
  else if (scope.level === "project") params.set("projectId", scope.projectId);
  const entries = search?.entries() ?? [];
  for (const [key, value] of entries) {
    if (!["scope", "teamId", "projectId"].includes(key)) params.append(key, value);
  }
  const tab = params.get("tab");
  const scopeTabs =
    scope.level === "deployment" ? ["license", "entitlements", "storage", "software-versions", "teams"] : ["members", "storage", "software-versions", ...(scope.level === "team" ? ["move-requests"] : [])];
  if (tab && !scopeTabs.includes(tab)) params.delete("tab");
  return `/settings?${params}`;
};
